import { Component, OnInit } from '@angular/core';
import { RegistationServiceService } from '../reg-services/registation-service.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { WebUserDetails } from '../../../../../shared/models/WebUserDetails';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { AlertMessages, AlertType } from '../../../../../core/AlertMessages'

@Component({
  selector: 'app-ha-register',
  templateUrl: './ha-register.component.html',
  styleUrls: ['./ha-register.component.css']
})

export class HaRegisterComponent implements OnInit {
  emailId: string;
  emailIsValid: boolean = true;
  dataSend: boolean = false;
  alertText: string;
  showAlert: boolean;
  showOverlay: boolean;
  userIsSpace: boolean;
  allUsers: WebUserDetails[];
  showProgress: boolean = false;
  basicFunctionvalue: string = "1";
  loadingExcelPercentage: number;
  username: string = "";
  password: string = "";
  cPassword: string = "";

  interval;
  clicked = false;

  constructor(private _service: RegistationServiceService, private router: Router) { }

  ngOnInit() {
    this.emailId = sessionStorage.getItem("Email");
  }

  checkUsername(emailText: string) {
    if (emailText.length > 5) {
      if (emailText.includes(' ')) {
        this.userIsSpace = true;
      } else {
        this.userIsSpace = false;
        this._service.checkEmailIfExist(emailText).subscribe((result) => {
          this.emailIsValid = result == 1 ? true : false;
        });
      }
    }
  }

  onRegister(form: NgForm) {
    this.dataSend = true;
    this.showProgress = true;

    this._service.registerUser(form.value.usern, form.value.pass, "1").subscribe((event) => {

      if (event.type === HttpEventType.UploadProgress) {
        this.loadingExcelPercentage = Math.round((event.loaded / event.total) * 100);
        let timeLeft: number = 12;
        this.interval = setInterval(() => {
          document.getElementById('hide').style.display = "block";
          if (timeLeft > 6) {
            document.getElementById('hide').innerHTML = "Creating ICD CODE";
            timeLeft--;
          } else if (timeLeft > 0 && timeLeft < 7) {
            document.getElementById('hide').innerHTML = "Creating CPT CODE";
            timeLeft--;
          }
          else if (timeLeft === 0) {
            clearInterval(this.interval);
            document.getElementById('hide').innerHTML = "Finalizing your account settings";
          }
        }, 1000);
      }
      else if (event.type == HttpEventType.Response) {
        this.showProgress = true;
        AlertMessages.Show('Success', 'Account created!', AlertType.Success);
        this.allUsers = JSON.parse(localStorage.getItem('userDetails'));
        this.allUsers.splice(this.allUsers.findIndex(i => i.id == JSON.parse(sessionStorage.getItem('Id'))), 1);
        localStorage.setItem('userDetails', JSON.stringify(this.allUsers));
        sessionStorage.clear();
        this.alertCloseRegister();
      }
    }, (error: HttpErrorResponse) => { AlertMessages.Show('Failed', 'Could not create!', AlertType.Error); }).add(() => this.showProgress = false);
  }

  alertCloseRegister() {
    setTimeout(() => {
      this.showAlert = false;
      this.router.navigate(['/login']);
    }, 1000);
  }

}
